// projectUtils.ts - Runtime functions for project management
import type { WorldBuildingData, PublishingEssentials } from '../types/core';
import { getDefaultWordCountForBookType } from './bookTypeUtils';

// Helper function to get project title from database project or fallback to currentProjectName
export const getProjectTitle = (dbProject?: { title: string } | null, fallbackTitle?: string | null): string => {
    return dbProject?.title || fallbackTitle || "Untitled Project";
};

// Helper function to sync blueprint.worldBuildingSuggestions.selectedStoryTitle with database project title
export const syncSelectedStoryTitleWithDB = (worldBuildingSuggestions: WorldBuildingData, dbProject?: { title: string } | null): WorldBuildingData => {
    if (dbProject?.title && dbProject.title !== worldBuildingSuggestions.selectedStoryTitle) {
        return {
            ...worldBuildingSuggestions,
            selectedStoryTitle: dbProject.title
        };
    }
    return worldBuildingSuggestions;
};

// Helper function to get target word count from database project
export const getTargetWordCount = (dbProject?: { targetWordCount: number; bookType?: string } | null, fallbackWordCount?: number): number => {
    return dbProject?.targetWordCount || fallbackWordCount || getDefaultWordCountForBookType(dbProject?.bookType || 'NOVEL');
};

// Helper function to get current word count from database project
export const getCurrentWordCount = (dbProject?: { currentWordCount?: number } | null, fallbackWordCount?: number): number => {
    return dbProject?.currentWordCount || fallbackWordCount || 0;
};